import { render, staticRenderFns } from "./TransactionViewUserInfoCard.vue?vue&type=template&id=e4f8d292&"
import script from "./TransactionViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./TransactionViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports